<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div v-if="lmodel !== null && vmodel !== null">
    <TabView class="page-layout">
      <!-- Setting -->
      <TabPanel header="Settings">
        <div>
          <div class="grid">
            <div class="col-12 lg:col-12">
              <h4 class="heading-text">{{ lmodel.friThankYouTitle }}</h4>
            </div>
          </div>
          <div class="grid mb-0">
            <div class="col-12 lg:col-12 py-0">
              <label
                v-tooltip.top="lmodel.friThanksScreenHeaderToolTip"
                For="friThanksScreenHeader-tooltip"
                class="control-label"
                >{{ staticData.header }}</label
              >
              <InputText
                v-model="vmodel1.friendThanksScreenTitle"
                id="friThanksScreenHeader"
                class="mt-1"
                :placeholder="lmodel.friThanksScreenHeaderPlaceholder"
              ></InputText>
            </div>
          </div>
          <div class="grid mb-0">
            <div class="col-12 lg:col-12">
              <label
                v-tooltip.top="lmodel.friThanksScreenBodyToolTip"
                For="friThanksScreenBody-tooltip"
                class="control-label"
                >{{ lmodel.friThanksScreenBody }}</label
              >
              <Textarea
                v-model="vmodel1.friendThanksScreenBody"
                type="text"
                autocomplete="off"
                :placeholder="lmodel.friThanksScreenBodyPlaceholder"
                class="mt-1 textareaBody"
                id="friThanksScreenBody"
              ></Textarea>
            </div>
          </div>

          <!-- Reward page -->
          <div class="grid mt-4">
            <div class="col-12 lg:col-12 py-0">
              <h4 class="heading-text">{{ lmodel.friRewardPage }}</h4>
            </div>
          </div>

          <div class="grid mb-0">
            <div class="col-12 lg:col-12">
              <label
                v-tooltip.top="lmodel.friRewardpageheaderToolTip"
                For="friRewardpageheader-tooltip"
                class="control-label"
                >{{ staticData.header }}
              </label>
              <InputText
                id="friRewardpageheader"
                class="mt-1"
                placeholder=""
              ></InputText>
            </div>
          </div>

          <div class="grid mb-0">
            <div class="col-12 lg:col-12">
              <label
                v-tooltip.top="lmodel.friRewardpagebodyToolTip"
                For="friRewardpagebody-tooltip"
                class="control-label"
                >{{ staticData.rwdpageterms }}</label
              >
              <Textarea
                type="text"
                autocomplete="off"
                placeholder=""
                class="mt-1 textareaBody"
                id="friRewardpagebody"
              ></Textarea>
            </div>
          </div>

          <!-- end -->

          <!-- Rewards -->
          <div class="grid mt-4">
            <div class="col-12 lg:col-12 py-0">
              <h4 class="heading-text">{{ staticData.rewardstitle }}</h4>
            </div>
          </div>

          <div class="grid mb-0">
            <div class="col-12 lg:col-12">
              <label
                v-tooltip.top=""
                For="friendSaveCodeSubject-tooltip"
                class="control-label"
                >{{ staticData.rwdexphead }}</label
              >
              <InputText id="header" class="mt-1" placeholder=""></InputText>
            </div>
          </div>

          <div class="grid mb-0">
            <div class="col-12 lg:col-12">
              <label
                v-tooltip.top=""
                For="friendSaveCodeSubject-tooltip"
                class="control-label"
                >{{ staticData.rwdexpbodytext }}</label
              >
              <Textarea
                type="text"
                autocomplete="off"
                placeholder=""
                class="mt-1 textareaBody"
                id="header"
              ></Textarea>
            </div>
          </div>

          <div class="grid mb-0">
            <div class="col-12 lg:col-12">
              <label
                v-tooltip.top=""
                For="friendSaveCodeSubject-tooltip"
                class="control-label"
                >{{ staticData.dealexphead }}</label
              >
              <InputText id="header" class="mt-1" placeholder=""></InputText>
            </div>
          </div>

          <div class="grid mb-0">
            <div class="col-12 lg:col-12">
              <label
                v-tooltip.top=""
                For="friendSaveCodeSubject-tooltip"
                class="control-label"
                >{{ staticData.dealexpbodytext }}</label
              >
              <Textarea
                type="text"
                autocomplete="off"
                placeholder=""
                class="mt-1 textareaBody"
                id="header"
              ></Textarea>
            </div>
          </div>

          <div class="grid mb-0">
            <div class="col-12 lg:col-12">
              <label
                v-tooltip.top=""
                For="friendSaveCodeSubject-tooltip"
                class="control-label"
                >{{ staticData.rwdusehead }}</label
              >
              <InputText id="header" class="mt-1" placeholder=""></InputText>
            </div>
          </div>

          <div class="grid mb-0">
            <div class="col-12 lg:col-12">
              <label
                v-tooltip.top=""
                For="friendSaveCodeSubject-tooltip"
                class="control-label"
                >{{ staticData.rwdusebodytext }}</label
              >
              <Textarea
                type="text"
                autocomplete="off"
                placeholder=""
                class="mt-1 textareaBody"
                id="header"
              ></Textarea>
            </div>
          </div>

          <div class="grid mb-0">
            <div class="col-12 lg:col-12">
              <label
                v-tooltip.top=""
                For="friendSaveCodeSubject-tooltip"
                class="control-label"
                >{{ staticData.rwdasgnhead }}</label
              >
              <InputText id="header" class="mt-1" placeholder=""></InputText>
            </div>
          </div>

          <div class="grid mb-0">
            <div class="col-12 lg:col-12">
              <label
                v-tooltip.top=""
                For="friendSaveCodeSubject-tooltip"
                class="control-label"
                >{{ staticData.rwdasgnbodytext }}</label
              >
              <Textarea
                type="text"
                autocomplete="off"
                placeholder=""
                class="mt-1 textareaBody"
                id="header"
              ></Textarea>
            </div>
          </div>

          <div class="grid mb-0">
            <div class="col-12 lg:col-12">
              <label
                v-tooltip.top=""
                For="friendSaveCodeSubject-tooltip"
                class="control-label"
                >{{ staticData.anyrwdasgnhead }}</label
              >
              <InputText id="header" class="mt-1" placeholder=""></InputText>
            </div>
          </div>

          <div class="grid mb-0">
            <div class="col-12 lg:col-12">
              <label
                v-tooltip.top=""
                For="friendSaveCodeSubject-tooltip"
                class="control-label"
                >{{ staticData.anyrwdasgnbodytext }}</label
              >
              <Textarea
                type="text"
                autocomplete="off"
                placeholder=""
                class="mt-1 textareaBody"
                id="header"
              ></Textarea>
            </div>
          </div>
        </div>
      </TabPanel>

      <!-- Styling  -->
      <TabPanel header="Styling"> </TabPanel>
    </TabView>
  </div>
</template>

<script>
import moment from "moment";
import staticData from "@/staticdata/static.json";

export default {
  components: {},

  props: {
    dealId: {
      type: String,
      default: null,
    },
    tabId: {
      type: Number,
      default: 0,
    },
    lmodel: {
      type: Object,
      default: null,
    },
    dmodel: {
      type: Object,
      default: null,
    },
    vmodel: {
      type: Object,
      default: null,
    },
    valmodel: {
      type: Object,
      default: null,
    },
    dealStatus: {
      type: Number,
      default: null,
    },
    isRedealText: {
      type: Boolean,
      default: false,
    },
    customerCampaignDealyDaysError: {
      type: String,
      default: null,
    },
    enableAmbassadorMailsAmb: {
      type: Boolean,
      default: false,
    },
    modelstate: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      staticData: staticData.returnvisit.settings,
      visible: false,
      errorMessage: true,
      //   showGeneralSettings: true,
      catchError: "",
      todayDt: moment(),
      copySucceeded: null,
      separatorExp: /,| /,
      id: this.$route.params.id,
      isAdvance: false,
      ShowChangePopup: false,
    };
  },
  computed: {
    vmodel1: {
      get() {
        return this.vmodel;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },

  watch: {},
  mounted() {
    document.body.style.overflow = "hidden";
  },
  methods: {
    toggleShowData() {
      this.showAll = !this.showAll;
    },

    onCopy: function () {
      this.copySucceeded = true;
    },
    onError: function () {
      this.copySucceeded = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.page-layout {
  margin-top: 180px;
  font-family: "Voyado Text";
}

input:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none !important;
  border: #c0c0bc !important;
  outline: 2px solid #222222 !important;
  border-style: double !important;
}
.p-inputtext:enabled:focus {
  outline: 0 none !important;
  outline-offset: 0 !important;
  box-shadow: none !important;
  border: #c0c0bc !important;
  outline: 2px solid #222222 !important;
  border-style: double !important;
}

:deep(.heading-text) {
  height: 18px !important;
  font-family: "Voyado Text" !important;
  font-size: 14.22px;
  font-weight: 500 !important;
  line-height: 17.1px;
  text-align: left;
}

input {
  color: #777 !important;
  font-size: 0.8rem;
  height: calc(1.5em + 0.75rem + 7px);
  width: 100%;
  box-shadow: none;
  border: 1px solid #c0c0bc;
  border-radius: 0.25rem;
  font-weight: 400;
  line-height: 1.5;
  padding: 0.375rem 0.75rem;
  font-family: "Voyado Text";
}

:deep(.p-inputtext) {
  color: #21211f !important;
  font-size: 16px;
  width: 100%;
  box-shadow: none;
  height: 40px !important;
  // border: 1px solid #c0c0bc;
  border-radius: 0.25rem;
  font-weight: 400;
  line-height: 1;
  padding: 0.375rem 0.75rem;
  font-family: "Voyado Text";
  resize: none;
}

:deep(.p-inputtext:enabled:focus) {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none;
  // border: 1px solid #cedacf;
}

h4 {
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  margin-top: 0;
  font-size: 1.5rem;
}

.control-label {
  font-size: 1rem;
  padding-bottom: 3px;
  display: block !important;
  margin-bottom: 0px;
  padding-top: 7px;
  font-weight: normal;
  position: relative;
  vertical-align: top;
}

:deep(.textareaBody) {
  height: 79px !important;
  .p-inputtextarea {
    height: 79px !important;
  }
}

.header-text h5 {
  margin: 0;
}

.header-text span {
  display: block;
  margin-top: 5px;
}

:deep(.p-tabview .p-tabview-nav li .p-tabview-nav-link:not(.p-disabled):focus) {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none !important;
}
:deep(.p-tabview .p-tabview-nav li .p-tabview-nav-link) {
  border: none !important;
  background: #ffffff;
  color: #000000;
  padding: 1rem 1.125rem 0rem;
  font-weight: 400;
  font-size: 14.22px;
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s,
    box-shadow 0.2s, outline-color 0.2s;
  margin: 0 0 -1px 0;
  outline-color: transparent;
}
:deep(.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link) {
  background: #ffffff;
  // border-color: #dee2e6 !important;
  border: 1px solid #dee2e6 !important;
  border-width: 0px 0px 1px 0px !important;
  color: #000000;
  font-weight: 400;
  font-size: 14.22px;
  line-height: 17.1px;
}
:deep(.p-tabview .p-tabview-nav li .p-tabview-nav-link span) {
  padding-bottom: 1rem;
  border: none;
}
:deep(.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link span) {
  padding-bottom: 1rem;
  border-bottom: 3px solid #791a3f;
}
:deep(.p-tabview .p-tabview-ink-bar) {
  display: none !important;
}

:deep(.p-tabview .p-tabview-panels) {
  padding: 16px !important;
  background: #ffffff;
  border: 0 none;
  color: #212529;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}

// .setting-layout {
//   margin-top: 180px;
//   font-family: "Voyado Text";
// }
:deep(.p-tabview .p-tabview-panels) {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: calc(100vh - 260px);
}

:deep(.p-tabview .p-tabview-panels) {
  padding: 16px !important;
}
</style>
